import { useTranslation } from 'react-i18next';

import { Label, LABEL_TYPE } from '@/components/generic';
import {
  LiveStreamingIcon,
  MusicNoteIcon,
  PictureIcon,
  ProfileTwoUser,
  StatsIcon
} from '@/resources/icons/registration-description';

import { RegisterDescriptionItem } from './RegisterDescriptionItem';

const registerFeatureItems = [
  {
    key: 'family',
    icon: ProfileTwoUser,
    titleKey: 'regFeatFamilyTitle',
    descriptionKey: 'regFeatFamilyDesc'
  },
  {
    key: 'music',
    icon: MusicNoteIcon,
    titleKey: 'regFeatMusicTitle',
    descriptionKey: 'regFeatMusicDesc'
  },
  {
    key: 'slideshow',
    icon: PictureIcon,
    titleKey: 'regFeatSlideTitle',
    descriptionKey: 'regFeatSlideDesc'
  },
  {
    key: 'stream',
    icon: LiveStreamingIcon,
    titleKey: 'regFeatStreamTitle',
    descriptionKey: 'regFeatStreamDesc'
  },
  {
    key: 'setup',
    icon: StatsIcon,
    titleKey: 'regFeatSetupTitle',
    descriptionKey: 'regFeatSetupDesc'
  }
] as const;

export const RegisterDescriptionPanel = () => {
  const [t] = useTranslation('common');

  return (
    <section className='bg-cream hidden p-8 md:flex md:flex-col lg:p-14 xl:p-20'>
      <div className='flex w-full flex-col gap-y-2'>
        <Label
          text={t('regHeroTitle')}
          type={LABEL_TYPE.H1}
          className='!font-newsreader !font-semibold !text-primary-black'
        />
        <Label
          text={t('regHeroSubtitle')}
          type={LABEL_TYPE.H1}
          className='!font-newsreader !font-semibold !text-primary-black'
        />
      </div>
      <div className='mt-4 w-full xl:w-2/3 2xl:w-2/3 3xl:w-1/2 4xl:w-2/5'>
        <Label text={t('regHeroDesc')} type={LABEL_TYPE.PARAGRAPH1} className='!text-slate-gray' />
      </div>

      <div className='mt-12 flex w-full flex-col gap-y-8'>
        {registerFeatureItems.map((item) => (
          <RegisterDescriptionItem
            key={item.key}
            Icon={item.icon}
            title={t(item.titleKey)}
            description={t(item.descriptionKey)}
          />
        ))}
      </div>
    </section>
  );
};
